export default {
  // dao首页
  'dao.title': 'VOTE FOR THE BEST PROJECTS ON THE CRYPTO MARKET',
  'dao.banner_desc': 'Cast your Vote and The Winning Project will be Listed for Free',
  'dao.banner_btn': 'Make a Vote',

  'dao.step_title_1': 'CHOOSE A PROJECT',
  'dao.step_desc_1': '3 projects - voting participants will be posted on this page. Choose the one you want to vote for.',

  'dao.step_title_2': 'USE $BIT TOKEN TO VOTE',
  'dao.step_desc_2': 'You vote using $BIT Token - the native token of the Biconomy.',

  'dao.step_title_3': 'WINNER WILL BE LISTED',
  'dao.step_desc_3': 'The project with the most votes gets a free listing on the Biconomy. The $BIT tokens received from the winning project will be burned.',

  'voting': 'Voting',
  'votes': 'Votes',

  'dao.start': 'About to start',
  'dao.in_voting': 'In Voting',
  'voting_history': 'Voting History',
  'proposals': 'Proposals',
  'disagree': 'Disagree',
  'invalid': 'Invalid',
  'start_date': 'Start Date',
  'end_date': 'End Date',
  'dao.read_more': 'Read more and vote',
  'rules': 'Rules',

  'dao.rules_1': '{num} projects are participating in the voting.',
  'dao.rules_2': 'Voting takes place within 3 full days.',
  'dao.rules_3': 'Voting takes place using our native $BIT token.',
  'dao.rules_4': 'When creating a voting project, you need to have and consume {num} BIT',
  'dao.rules_5': 'Each vote costs ≈ $3 in $BIT equivalent - {num} $BIT.',
  'dao.rules_6': 'The project that receives the maximum number of votes will be listed in 3 days after the end of the voting.',
  'dao.rules_7': 'The minimum number of votes that the winning project must receive is at least 1000. If none of the projects reaches this number, voting is considered invalid.',
  'dao.rules_8': 'All $BIT tokens that were received during the voting for the winning project will be completely burned.',
  'Terms & Conditions': 'Terms & Conditions',
  'dao.term_1': 'Participants are required to complete KYC verification.',
  'dao.term_2': 'Biconomy reserves the right to final decision on all aspects of the event and has the right to disqualify any participants who are found to be involved in any cheating behaviors.',

  // dao详情页
  'attachment': 'Attachment',
  'creator': 'Creator',
  'dao.proposed_date': 'Proposed date',
  'dao.proposal_id': 'Proposal ID',
  'dao.think': 'What do you think?',
  'dao.consume': 'Voting will consume {num} BIT',
  'dao.detail_agree': 'I agree',
  'dao.disagree': 'I don’t agree',
  'vote': 'Vote',
  'confirmation': 'Confirmation',
  'dao.detail_modal_content': 'Note that after voting you will not be able to cancel your vote. Voting will consume your BITs immediately from your balance. Proposals that have 100+ votes and are agreed by the majority will be executed. Are you sure you want to vote? ',
  'dao.close': 'Close In',
  'dao.start_in': 'Start In',
  'bit.insufficient': 'Insufficient BIT Balance',
  'BIT.Balance': 'BIT Balance',

  // Dao 列表页
  'dao.my_title': 'My Proposals',
  'rejected': 'Rejected',
  'activated': 'Activated',
  'dao.BIT_consumption': 'BIT consumption',
  'dao.review_status': 'Review Status',
  'dao.voting_status': 'Voting Status',
  'dao.proposal_date': 'Proposal created date',
  'dao.list_modal_btn': 'Submit another proposal',

  // dao提案页
  'dao.proposal': 'Submit a proposal',
  'max_words': 'Max {num} words',
  'dao.file_type': 'jpg, pdf, png only, max upload 1 mb',
  'dao.principles_title': 'Proposal principles',
  'dao.principles_1': 'political or sensitive topics',
  'dao.principles_2': 'violation of laws, regulations and ethics',
  'dao.principles_3': 'porn, gambling, drugs and related content',
  'dao.principles_4': 'damage to the interests of the platform',
  'dao.principles_5': 'damage to the interests of other users or violation of their privacy',
  'dao.principles_6': 'The platform reserves the right to ignore the proposals that do not comply with the previous points',
  'dao.principles_bit': 'BIT equivalent to 10 USDT will be deducted for each proposal submitted, the exact amount will be adjusted once a month according to the BIT price',
  'consumption': 'Consumption',
  'dao.proposal_modal_content': 'Note that after submission your proposal will be send for review immediately and you will not be able to edit the proposal during the review period. Are you sure you want to submit the proposal for review? ',
  'dao.file_limit': 'The file size is limited to 1 MB',
  'upload.success': 'Upload Success',
  'vote_success': 'Vote success',
  'upload': 'Upload',
};
